import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrlPropertydemat, baseUrl28 } from "../BaseUrl/baseurl";
import http from "../BaseUrl/baseurl";
import axios from "axios";

export const verifyInvestor = createAsyncThunk("verifyInvestor", async id => {
    console.log("id", id);
    try {
        const response = await axios.put(
            `${baseUrlPropertydemat}/auth/updateDocumentStatus`,
            { userId: id }
        );
        // console.log("verifyInvestor response", response?.data);
        return response.data;
    } catch (error) {
        return error.response.data;
    }
});

export const getInvestorVerificationDetails = createAsyncThunk(
    "getInvestorVerificationDetails",
    async id => {
        try {
            const response = await axios.get(
                `${baseUrlPropertydemat}/auth/getUserData/${id}`
            );
            // console.log("verifyInvestor response", response?.data);
            return response.data;
        } catch (error) {
            return error.response.data;
        }
    }
);

export const getInvestorList = createAsyncThunk("getInvestorlist", async () => {
    const response = await axios.get(`${baseUrl28}/users/investor`);
    console.log("InvestorResponse", response);
    return response.data;
});

export const getUserKycData = createAsyncThunk(
    "getUserKycData",
    async ({ id, data }) => {
        console.log("slice img", id, data);
        const response = await axios.get(
            `${baseUrl28}/users/get-kyc/${id}`,
            data
        );
        console.log("User kyc Response", response);
        return response.data;
    }
);

// const userId = localStorage.getItem("userId");
const token = localStorage.getItem("token");

export const getKycInvestorUserid = createAsyncThunk(
    "getKycInvestorUserid",
    async (userId, { dispatch }) => {
        dispatch(clearKycUserid());
        const response = await axios.get(
            `${baseUrl28}/users/get-kyc/${userId}`
        );
        console.log("investorKycResponse------>", response);
        return response.data;
    }
);

export const getInvestorById = createAsyncThunk("getInvestorById", async id => {
    const response = await axios.get(`${baseUrl28}/users/UserDetails/${id}`);
    console.log("InvestorResponse", response);
    return response.data;
});

// Define the initial state for the slice
const initialState = {
    Investors: [],
    Investor: {},
    KycUserid: {},
    KycData: {},
    status: "",
    error: ""
};

const InvestorSlice = createSlice({
    name: "investor",
    initialState,
    reducers: {
        clearKycUserid: state => {
            state.KycUserid = {}; // Clear the KYC data for a specific user
        }
    },
    extraReducers(builder) {
        // add Investor
        builder
            .addCase(verifyInvestor.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(verifyInvestor.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.Investor = action.payload;
            })
            .addCase(verifyInvestor.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            })
            .addCase(
                getInvestorVerificationDetails.pending,
                (state, action) => {
                    state.status = "loading";
                }
            )
            .addCase(
                getInvestorVerificationDetails.fulfilled,
                (state, action) => {
                    state.status = "succeeded";
                    state.Investor = action.payload;
                }
            )
            .addCase(
                getInvestorVerificationDetails.rejected,
                (state, action) => {
                    state.status = "failed";
                    state.error = action.error.message;
                }
            )
            .addCase(getInvestorList.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getInvestorList.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.Investors = action.payload;
            })
            .addCase(getInvestorList.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            })
            //kyc list
            .addCase(getKycInvestorUserid.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getKycInvestorUserid.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.KycUserid = action.payload;
            })
            .addCase(getKycInvestorUserid.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            })
            .addCase(getUserKycData.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.KycData = action.payload;
            })

            .addCase(getInvestorById.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getInvestorById.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.Investor = action.payload;
            })
            .addCase(getInvestorById.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });
    }
});
export const { clearKycUserid } = InvestorSlice.actions;

export default InvestorSlice.reducer;
